<template>
  <div>
    <div class="info-box">
      <div class="title-box">
        <p>发起活动</p>
      </div>
      <div class="info-content" v-loading="loading" :element-loading-text="loadingText">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <el-form ref="activityForm" :model="data" :rules="rules" label-width="120px">
                  <el-form-item label="活动名称" prop="name">
                    <el-input v-model="data.name" style="width:600px;"></el-input>
                  </el-form-item>

                  <el-form-item label="活动封面" required>
                    <el-form-item prop="cover_photo">
                      <WtPoster
                        ref="coverRef"
                        v-model="data.cover_photo"
                        :picPath="data.cover_photo_path"
                      />
                    </el-form-item>
                  </el-form-item>

                  <el-form-item label="活动类型" prop="type">
                    <el-select v-model="data.type" placeholder="请选择活动类型" style="width:300px;">
                      <el-option
                        v-if="info.identity_type == 1 && !info.college_student_id"
                        v-for="item in options"
                        :key="item.value"
                        :value="parseInt(item.value)"
                        :label="item.name"
                      ></el-option>
                      <!--反哺大学生可以发起反哺活动及顺丰地区活动-->
                      <template v-if="info.college_student_id">
                        <el-option
                          v-for="item in types"
                          :key="item.id"
                          :value="parseInt(item.id)"
                          :label="item.name"
                        ></el-option>
                      </template>
                      <!--普通志愿者只可以发起顺丰地区活动-->
<!--                      <template v-else>-->
<!--                        <el-option-->
<!--                          v-for="item in $store.state.dictList.activity_type"-->
<!--                          :key="item.value"-->
<!--                          :value="parseInt(item.value)"-->
<!--                          v-if="item.value==3"-->
<!--                          :label="item.name"-->
<!--                        ></el-option>-->
<!--                      </template>-->
                    </el-select>
                  </el-form-item>
                  <el-form-item label="活动发起人">
                    <el-input v-model="data.launch_user" style="width:400px;"></el-input>
                  </el-form-item>
                  <el-form-item label="承办组织">
                    <el-input v-model="data.launch_organization" style="width:400px;"></el-input>
                  </el-form-item>
                  <el-form-item label="活动时间" required>
                    <el-col :span="6">
                      <el-form-item prop="activity_start">
                        <el-date-picker
                          type="date"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm"
                          placeholder="选择活动开始日期"
                          v-model="data.activity_start"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1" style="text-align: center;">-</el-col>
                    <el-col :span="6">
                      <el-form-item prop="activity_end">
                        <el-date-picker
                          placeholder="选择活动结束日期"
                          type="date"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm"
                          v-model="data.activity_end"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="报名时间" required>
                    <el-col :span="6">
                      <el-form-item prop="sign_up_start">
                        <el-date-picker
                          type="date"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择报名开始时间"
                          v-model="data.sign_up_start"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1" style="text-align: center;">-</el-col>
                    <el-col :span="6">
                      <el-form-item prop="sign_up_end">
                        <el-date-picker
                          placeholder="选择报名截止时间"
                          type="date"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          v-model="data.sign_up_end"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="活动地点" required>
                    <el-form-item
                      prop="defaultAreaList"
                      style="display:inline-block;margin-right: 0;"
                    >
                      <WtDataArea v-model="data.defaultAreaList" v-if="areaShow"></WtDataArea>
                    </el-form-item>
                    <el-form-item prop="address" style="display:inline-block;margin-right: 0;">
                      <el-input v-model="data.address" style="width:400px;"></el-input>
                    </el-form-item>
                  </el-form-item>
                  <el-form-item label="活动招募人数" prop="people_num">
                    <el-input v-model.number="data.people_num" type="age" style="width:400px;"></el-input>
                    <i class="el-icon-warning"></i>&nbsp;活动招募人数，0表示不限制报名人数
                  </el-form-item>
                  <div class="editor">
                    <el-form-item label="活动内容" prop="content">
                      <vue-ueditor-wrap v-model="data.content" :destroy="true" :config="myConfig"></vue-ueditor-wrap>
                    </el-form-item>
                  </div>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm">{{buttonText}}</el-button>
                    <el-button @click="$router.go(-1)">取消</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      types:[],
      options: [{
        value: '3',
        name: '地区公益活动'
      }],
      buttonText:"立即创建",
      info: {}, //用户信息
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度不能超过 20 个字符",
            trigger: "blur"
          }
        ],
        cover_photo: [{ required: true, message: "请上传活动封面图" }],
        type: [
          {
            required: true,
            message: "请选择活动类型",
            trigger: "change"
          }
        ],
        activity_start: [
          {
            type: "string",
            required: true,
            message: "请选择活动开始时间",
            trigger: "change"
          }
        ],
        activity_end: [
          {
            type: "string",
            required: true,
            message: "请选择活动结束时间",
            trigger: "change"
          }
        ],
        sign_up_start: [
          {
            type: "string",
            required: true,
            message: "请选择活动报名开始时间",
            trigger: "change"
          }
        ],
        sign_up_end: [
          {
            type: "string",
            required: true,
            message: "请选择活动报名截止时间",
            trigger: "change"
          }
        ],
        defaultAreaList: [
          {
            required: true,
            message: "请选择活动地点",
            trigger: "change",
            type: "array"
          }
        ],
        address: [
          { required: true, message: "请输入活动详细地址", trigger: "blur" }
        ],
        people_num: [
          {
            required: true,
            message: "请填写活动招募人数，0表示不限制",
            trigger: "blur",
            type: "number"
          }
        ],
        content: [
          { required: true, message: "请填写活动内容", trigger: "blur" }
        ]
      },
      loading: true,
      loadingText: "拼命加载中",
      areaShow: false,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: "100%",
        zIndex: 1000,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: this.$url.upload.uploadEditor
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        //UEDITOR_HOME_URL: "/static/UEditor/"
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      radio: 3,
      dialogVisible: false,
      data: {
        defaultAreaList: [],
        content:
          "<h3>1、活动说明</h3><h3>2、活动背景</h3><h3>3、志愿者要求</h3><h3>4、注意事项</h3><p>活动联系人：</p><p>联系人电话：</p><p>联系人邮箱：</p>"
      },
      search: {
        type: null
      },

      navStatus: 1
    };
  },
  methods: {
    submitForm() {
      let self = this;
      this.$refs.activityForm.validate(valid => {
        if (valid) {
          self.loading = true;
          self.loadingText = "正在执行中";
          self.data.province = self.data.defaultAreaList[0];
          self.data.city = self.data.defaultAreaList[1];
          self.data.country = self.data.defaultAreaList[2];
          if (self.data.id) {
            //编辑活动
            self.$db
              .put(self.$url.activity.url + "/" + self.data.id, self.data)
              .then(resp => {
                if (resp) {
                  self.loading = false;
                  // self.$notify({
                  //   title: "提示信息",
                  //   message: "活动编辑成功，请等待管理员审核",
                  //   type: "success",
                  //   onClose: function() {
                  //     self.$router.push({ name: "centerActivityList" });
                  //   }
                  // });
                  self.$alert("活动编辑成功", "提示", {
                    confirmButtonText: "确定并返回",
                    type: 'success',
                    callback: action => {
                      self.$router.push({ name: "centerActivityList" });
                    }
                  });
                }
              });
          } else {
            //新增活动
            self.$db.post(self.$url.activity.url, self.data).then(resp => {
              if (resp && resp.data) {
                self.loading = false;
                // self.$notify({
                //   title: "提示信息",
                //   message: "活动创建成功，请等待管理员审核",
                //   type: "success",
                //   onClose: function() {
                //     self.$router.push({ name: "centerActivityList" });
                //   }
                // });
                self.$alert("活动创建成功", "提示", {
                  confirmButtonText: "确定并返回",
                  type: 'success',
                  callback: action => {
                    self.$router.push({ name: "centerActivityList" });
                  }
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row, false);
    },
    handleEdit(data) {
      console.log(data);
      this.dialogVisible = true;
    },
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index / 3);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg2";
      }
    }
  },
  mounted() {
    let id = this.$route.query.id;
    if (id) {
      this.buttonText = "保存修改"
      //this.ViewLoading();
      this.data.cover_photo_path = "";
      //有传入id，获取对于的活动信息
      this.$db.get(this.$url.activity.detail + "/" + id).then(resp => {
        this.data = resp.data;
        console.log(this.data,"datalll")
        this.data.defaultAreaList = new Array(3);
        this.data.defaultAreaList[0] = this.data.province;
        this.data.defaultAreaList[1] = this.data.city;
        this.data.defaultAreaList[2] = this.data.country;
        this.areaShow = true;
        if (this.data.cover_photo) {
          this.data.cover_photo_path = this.data.cover_photo_text[0].path;
        }
        this.loading = false;
      });
    } else {
      this.buttonText = "立即创建"
      this.$db.get(this.$url.user.url).then(resp => {
        //查询当前登录用户的身份，是否可以发起活动，以及是否可以发起反哺活动
        this.info = resp.data;
        //查询反哺学生活动分类
        this.$db.post(this.$url.activity.type.list,{pid:3}).then(resp=>{
          this.types = resp.data;
        })
        this.areaShow = true;
        this.loading = false;
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.profile-position {
  padding: 5px 0;
  color: #515a6e;
}
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;
    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#app-activity {
  width: 100%;
  // margin-bottom: 45px;
  background-color: #f5f5f5;
}
.activity-box {
  margin: 0 auto;
  padding: 15px 0;
  .activity-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 24px;
        font-weight: normal;
        color: #999999;
      }
      > h3 {
        font-size: 24px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      width: 308px;
      > ul {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        > li {
          list-style: none;
          margin-right: 30px;
          font-size: 15px;
          font-weight: normal;
          color: #333333;
          padding-bottom: 3px;
          cursor: pointer;
          // &:last-child { // margin-right: 0; // }
          &.active {
            border-bottom: 2px solid #e83a16;
            color: #e83a16;
          }
        }
      }
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .activity-bottom {
    width: 100%;
    > ul {
      flex-wrap: wrap;
      display: flex;
      //justify-content: space-between;
      .liBg1 {
        background-color: #89ba29;
      }
      .liBg2 {
        background-color: #89ba29;
      }
      .liBg3 {
        background-color: #f8b92b;
      }
      > li {
        list-style: none;
        width: 29%;
        margin: 0px 25px 25px 25px;
        background-color: #89ba29;
        box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
        position: relative;
        cursor: pointer;
        &:hover {
          .act-bottom {
            > p {
              color: #eee;
            }
            > h3 {
              color: #eee;
            }
          }
        }

        .act-top {
          width: 100%;
          //height: 210px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .act-center {
          position: absolute;
          width: 75px;
          height: 47px;
          background-color: #ffffff;
          left: 24px;
          top: 175px;
          padding: 14px 0;
          > p {
            font-size: 14px;
            font-weight: normal;
            color: #89ba29;
            text-align: center;
          }
          > h5 {
            font-size: 24px;
            font-weight: normal;
            color: #89ba29;
            text-align: center;
          }
        }
        .act-bottom {
          padding: 63px 34px 28px 24px;
          > p {
            font-size: 16px;
            font-weight: normal;
            color: #ffffff;
            margin-bottom: 18px;
          }
          > h3 {
            font-size: 14px;
            font-weight: normal;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.same_city_Li_dizhiQu {
  width: 100%;
  height: 22px;
  margin-top: 4px;
}
.same_city_Li_time {
  display: inline-block;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
  float: left;
  margin-right: 15px;
}
.same_city_Li_address {
  display: inline-block;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}

.status {
  position: absolute;
  width: 130px;
  right: 0px;
  top: 0px;
  color: #fff;
  font-size: 14px;
  line-height: 36px;
  font-weight: 500;
  text-align: center;
}
.status.ing {
  background-color: rgba(255, 111, 2, 0.8);
}
.status.end {
  background-color: #999;
}
.status.coming {
  background-color: #f8b92b;
}
</style>

<style>
.editor .el-form-item__content {
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/activity/info.vue